import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import algoliasearch from 'algoliasearch/lite';
import {
  InstantSearch,
  Configure,
  SearchBox,
  Pagination,
  connectHits,
  connectHighlight,
} from 'react-instantsearch-dom';
import PropTypes from 'prop-types';
import './App.css';
import { Card, CardContent, CardHeader, CardMedia, Grid } from '@mui/material';
import { Box, Container } from '@mui/system';
import * as qs from 'qs';
const jsmediatags = window.jsmediatags;
const searchClient = algoliasearch(
  'FK3G9IGP3K',
  '89d475e899020c58b2df98db0823110f'
);
const DEBOUNCE_TIME = 400;

const createURL = state => `?${qs.stringify(state)}`;

const searchStateToUrl = searchState =>
  searchState ? createURL(searchState) : '';

const urlToSearchState = ({ search }) => qs.parse(search.slice(1));

const loadImageData = id =>
  new Promise(resolve => {
    jsmediatags.read(`https://oldd.acab.gay/music/${id}.mp3`, {
      onSuccess: tag => {
        const image = tag.tags.picture;
        if (image) {
          let base64String = '';
          for (let i = 0; i < image.data.length; i++) {
            base64String += String.fromCharCode(image.data[i]);
          }
          const base64 = `data:${image.format};base64,${window.btoa(
            base64String
          )}`;
          resolve(base64);
        } else {
          resolve(null);
        }
      },
      onError: () => resolve(null),
    });
  });
const Hit = ({ hit }) => {
  const [imageData, setImageData] = useState();
  useEffect(() => {
    const getData = async () => {
      setImageData(await loadImageData(hit.track.track_id));
    };
    getData();
  }, []);
  return (
    <Grid item xs={12}>
      <Card variant="outlined" padding={10}>
        <CardHeader
          title={<CustomHighlight attribute="track.track_name" hit={hit} />}
          subheader={<CustomHighlight attribute="track.album_name" hit={hit} />}
        />
        {imageData && (
          <CardMedia
            alt="green iguana"
            image={imageData}
            style={{ height: 0, paddingTop: '15%' }}
          />
        )}
        <CardContent>
          {renderAudio(hit.track.track_id)}
          <p>
            <CustomHighlight attribute="content" hit={hit} />
          </p>
          <p className="trackId">{hit.track.track_id}</p>
        </CardContent>
      </Card>
    </Grid>
  );
};
Hit.propTypes = {
  hit: PropTypes.object.isRequired,
};
const Hits = ({ hits }) => (
  <Grid container spacing={2}>
    {hits
      .filter(hit => hit.content)
      .map(hit => (
        <Hit hit={hit} key={`hit#${hit.track.track_id}`} />
      ))}
  </Grid>
);

Hits.propTypes = {
  hits: PropTypes.array.isRequired,
};

const Highlight = ({ highlight, attribute, hit }) => {
  const parsedHit = highlight({
    highlightProperty: '_highlightResult',
    attribute,
    hit,
  });

  return (
    <span>
      {parsedHit.map((part, index) =>
        part.isHighlighted ? (
          <mark key={index}>{part.value}</mark>
        ) : (
          <span key={index}>
            {part.value.split('\n').map((l, i) => (
              <span key={`${index}sub${i}`}>
                {i === 0 || <br />}
                {l}
              </span>
            ))}
          </span>
        )
      )}
    </span>
  );
};

Highlight.propTypes = {
  highlight: PropTypes.func.isRequired,
  attribute: PropTypes.string.isRequired,
  hit: PropTypes.object.isRequired,
};

const CustomHighlight = connectHighlight(Highlight);

const CustomHits = connectHits(Hits);

export function App() {
  const navigate = useNavigate();
  const location = useLocation();

  const [searchState, setSearchState] = useState(urlToSearchState(location));
  const debouncedSetStateRef = useRef(null);

  function onSearchStateChange(updatedSearchState) {
    clearTimeout(debouncedSetStateRef.current);

    debouncedSetStateRef.current = setTimeout(() => {
      navigate(searchStateToUrl(updatedSearchState));
    }, DEBOUNCE_TIME);

    setSearchState(updatedSearchState);
  }

  useEffect(() => {
    setSearchState(urlToSearchState(location));
  }, [location]);

  return (
    <Container>
      <Box pt={3}>
        <InstantSearch
          searchClient={searchClient}
          indexName="lyrics"
          searchState={searchState}
          onSearchStateChange={onSearchStateChange}
          createURL={createURL}
        >
          <Configure hitsPerPage={8} />
          <div className="search-panel">
            <div className="search-panel__results">
              <SearchBox
                className="searchbox"
                translations={{
                  placeholder: '',
                }}
              />
              <CustomHits />

              <div className="pagination">
                <Pagination />
              </div>
            </div>
          </div>
        </InstantSearch>
      </Box>
    </Container>
  );
}

function renderAudio(id) {
  return (
    <audio
      src={`music/${id}.mp3`}
      controls
      onError={e => {
        e.target.style.display = 'none';
      }}
      key={`audio${id}`}
    />
  );
}

export default App;
